import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const SearchResults = styled.div`
  margin: 0 auto;
  padding-left: 16px;
  padding-right: 8px;
`

export const SearchResultsItem = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.white};
  z-index: 1000;
  cursor: pointer;
  transition: background-color 0.2s ease-out;
  padding-top: 11px;
  padding-bottom: 11px;

  @media ${device.mobileMin} {
    padding-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.greyBlue};
  }
`

export const SearchResultsImg = styled.img`
  width: 40px;
  height: 40px;
  margin-right: 16px;
  margin-top: 3px;
  margin-bottom: 3px;
  border-radius: 4px;
`

export const SearchResultsText = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
  height: 100%;
  text-align: left;
  line-height: 21px;
  font-size: ${variables.fontSize14};
`

export const SearchResultsTitle = styled.div`
  color: ${colors.mainText};
  font-weight: 600;
  font-size: ${variables.fontSize14};
  line-height: 21px;
  @media ${device.mobileMin} {
    margin-bottom: 4px;
  }
`

export const SearchResultsDescription = styled.div`
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`
